import React from 'react';
import IconBase, { iconPropTypes } from '../IconBase';

export default function FramingIcon(props) {
	return (
		<IconBase type="framing" {...props}>
			<path d="M12 3.5L22 12.5H19V20.5H18V12.5H15.5V20.5H14.5V12.5H12V20.5H5V12.5H2L12 3.5ZM18.4615 11.5L15.737 8.97009L13.2071 11.5H18.4615ZM6 11.5H10.7929L8.39646 9.10352L6 11.5ZM12.5 5.96433V10.7929L15.0037 8.28917L12.5 5.96433ZM9.10357 8.39641L11.5 10.7928V5.99995L9.10357 8.39641ZM7 16.5H10V13.5H7V16.5Z" />
		</IconBase>
	);
}
FramingIcon.propTypes = iconPropTypes;
